module.exports = __webpack_public_path__ + "img/is-demand-driven.f337aaca.svg";